import {z} from 'zod';

export default z.object({
    text: z.string(),
    title: z.string(),
    href: z.string(),
    target: z.enum('_blank', '_self', '_parent', '_top').optional(),
    rel: z.array(z.enum('nofollow', 'noreferrer', 'noopener')).optional(),
    classList: z.array(z.string()).optional(),
});
